import personMathys from './images/mathys/svg/person.svg';
import plusMathys from './images/mathys/svg/plus-lg.svg';
import logoMathys from './images/mathys/png/logo.png';
import arrowDownMathys from './images/mathys/svg/chevron-down.svg';
import arrowLeftMathys from './images/mathys/svg/chevron-left.svg';
import arrowRightMathys from './images/mathys/svg/chevron-right.svg';
import trashMathys from './images/mathys/svg/trash.svg';
import dashMathys from './images/mathys/svg/dash.svg';
import withdrawalMathys from './images/mathys/svg/withdrawal.svg';
import customerAccountMathys from './images/mathys/svg/customer-account.svg';
import checkTicketMathys from './images/mathys/svg/ticket-check.svg';
import searchMathys from './images/mathys/svg/search.svg';
import personMeziz from './images/meziz/svg/person.svg';
import plusMeziz from './images/meziz/svg/plus-lg.svg';
import logoMeziz from './images/meziz/png/Icon_mezizbet_96x96.png';
import logoMezizLg from './images/meziz/png/Icon_mezizbet_384x384.png';
import arrowDownMeziz from './images/meziz/svg/chevron-down.svg';
import arrowDownMezizCon from './images/meziz/svg/chevron-down-white.svg';
import arrowLeftMeziz from './images/meziz/svg/chevron-left.svg';
import arrowRightMeziz from './images/meziz/svg/chevron-right.svg';
import trashMeziz from './images/meziz/svg/trash.svg';
import dashMeziz from './images/meziz/svg/dash.svg';
import withdrawalMeziz from './images/meziz/svg/withdrawal.svg';
import customerAccountMeziz from './images/meziz/svg/customer-account.svg';
import checkTicketMeziz from './images/meziz/svg/ticket-check.svg';
import searchMeziz from './images/meziz/svg/search.svg';
import personLnb from './images/lnb/svg/person.svg';
import plusLnb from './images/lnb/svg/plus-lg.svg';
import logoLnb from './images/lnb/png/logo.png';
import arrowDownLnb from './images/lnb/svg/chevron-down.svg';
import arrowDownLnbCon from './images/lnb/svg/chevron-down-white.svg';
import arrowLeftLnb from './images/lnb/svg/chevron-left.svg';
import arrowRightLnb from './images/lnb/svg/chevron-right.svg';
import trashLnb from './images/lnb/svg/trash.svg';
import dashLnb from './images/lnb/svg/dash.svg';
import withdrawalLnb from './images/lnb/svg/withdrawal.svg';
import customerAccountLnb from './images/lnb/svg/customer-account.svg';
import checkTicketLnb from './images/lnb/svg/ticket-check.svg';
import searchLnb from './images/lnb/svg/search.svg';
import personFlexbet from './images/flexbet/svg/person.svg';
import plusFlexbet from './images/flexbet/svg/plus-lg.svg';
import logoFlexbet from './images/flexbet/png/logo.png';
import arrowDownFlexbet from './images/flexbet/svg/chevron-down.svg';
import arrowDownFlexbetCon from './images/flexbet/svg/chevron-down-white.svg';
import arrowLeftFlexbet from './images/flexbet/svg/chevron-left.svg';
import arrowRightFlexbet from './images/flexbet/svg/chevron-right.svg';
import trashFlexbet from './images/flexbet/svg/trash.svg';
import dashFlexbet from './images/flexbet/svg/dash.svg';
import withdrawalFlexbet from './images/flexbet/svg/withdrawal.svg';
import customerAccountFlexbet from './images/flexbet/svg/customer-account.svg';
import checkTicketFlexbet from './images/flexbet/svg/ticket-check.svg';
import searchFlexbet from './images/flexbet/svg/search.svg';
import personPrimebet from './images/primebet/svg/person.svg';
import plusPrimebet from './images/primebet/svg/plus-lg.svg';
import logoPrimebet from './images/primebet/png/logo.png';
import arrowDownPrimebet from './images/primebet/svg/chevron-down.svg';
import arrowDownPrimebetCon from './images/primebet/svg/chevron-down-white.svg';
import arrowLeftPrimebet from './images/primebet/svg/chevron-left.svg';
import arrowRightPrimebet from './images/primebet/svg/chevron-right.svg';
import trashPrimebet from './images/primebet/svg/trash.svg';
import dashPrimebet from './images/primebet/svg/dash.svg';
import withdrawalPrimebet from './images/primebet/svg/withdrawal.svg';
import customerAccountPrimebet from './images/primebet/svg/customer-account.svg';

const themeAssets = {
  mathys: {
    person: personMathys,
    plus: plusMathys,
    logo: logoMathys,
    logoLg: logoMathys,
    arrowDownCon: arrowDownMathys,
    arrowDown: arrowDownMathys,
    arrowLeft: arrowLeftMathys,
    arrowRight: arrowRightMathys,
    trash: trashMathys,
    dash: dashMathys,
    withdrawal: withdrawalMathys,
    customerAccount: customerAccountMathys,
    checkTicket: checkTicketMathys,
    search: searchMathys,
  },
  meziz: {
    person: personMeziz,
    plus: plusMeziz,
    logo: logoMeziz,
    logoLg: logoMezizLg,
    arrowDownCon: arrowDownMezizCon,
    arrowDown: arrowDownMeziz,
    arrowLeft: arrowLeftMeziz,
    arrowRight: arrowRightMeziz,
    trash: trashMeziz,
    dash: dashMeziz,
    withdrawal: withdrawalMeziz,
    customerAccount: customerAccountMeziz,
    checkTicket: checkTicketMeziz,
    search: searchMeziz,
  },
  lnb: {
    person: personLnb,
    plus: plusLnb,
    logo: logoLnb,
    logoLg: logoLnb,
    arrowDownCon: arrowDownLnbCon,
    arrowDown: arrowDownLnb,
    arrowLeft: arrowLeftLnb,
    arrowRight: arrowRightLnb,
    trash: trashLnb,
    dash: dashLnb,
    withdrawal: withdrawalLnb,
    customerAccount: customerAccountLnb,
    checkTicket: checkTicketLnb,
    search: searchLnb,
  },
  flexbet: {
    person: personFlexbet,
    plus: plusFlexbet,
    logo: logoFlexbet,
    logoLg: logoFlexbet,
    arrowDownCon: arrowDownFlexbetCon,
    arrowDown: arrowDownFlexbet,
    arrowLeft: arrowLeftFlexbet,
    arrowRight: arrowRightFlexbet,
    trash: trashFlexbet,
    dash: dashFlexbet,
    withdrawal: withdrawalFlexbet,
    customerAccount: customerAccountFlexbet,
    checkTicket: checkTicketFlexbet,
    search: searchFlexbet,
  },
  primebet: {
    person: personPrimebet,
    plus: plusPrimebet,
    logo: logoPrimebet,
    logoLg: logoPrimebet,
    arrowDownCon: arrowDownPrimebetCon,
    arrowDown: arrowDownPrimebet,
    arrowLeft: arrowLeftPrimebet,
    arrowRight: arrowRightPrimebet,
    trash: trashPrimebet,
    dash: dashPrimebet,
    withdrawal: withdrawalPrimebet,
    customerAccount: customerAccountPrimebet,
  },
};

const DEFAULT_CLIENT = 'mathys';

export const getClientName = () => {
  const client = process.env.REACT_APP_CLIENT;

  if (client && themeAssets[client]) {
    return client;
  }

  return DEFAULT_CLIENT;
};

export const getClientThemeAssets = () => themeAssets[getClientName()];

export const getClientThemeAsset = (assetName) => getClientThemeAssets()[assetName];

export const getClientLogo = () => getClientThemeAsset('logo');

export const getClientLogoLg = () => getClientThemeAsset('logoLg');

export default themeAssets;
